/**
 * Telephony and Twilio-related type definitions
 * These types are used across the application for voice call functionality
 */
/**
 * Conference participant types for identification and management
 * Used to track different types of participants in voice conferences
 */
export var ConferenceParticipantType;
(function (ConferenceParticipantType) {
    /** Customer/caller who initiated the call */
    ConferenceParticipantType["CUSTOMER"] = "customer";
    /** AI agent (LiveKit) handling the conversation */
    ConferenceParticipantType["LIVEKIT_AGENT"] = "livekit_agent";
    /** Human staff member joining for handoff */
    ConferenceParticipantType["STAFF_MEMBER"] = "staff_member";
})(ConferenceParticipantType || (ConferenceParticipantType = {}));
/**
 * Conference participant labels for Twilio conference management
 * These are the actual string values used in Twilio conference participant labels
 */
export const CONFERENCE_PARTICIPANT_LABELS = {
    [ConferenceParticipantType.CUSTOMER]: 'customer',
    [ConferenceParticipantType.LIVEKIT_AGENT]: 'ai-agent',
    [ConferenceParticipantType.STAFF_MEMBER]: 'staff',
};
//# sourceMappingURL=telephony.js.map